/**
 * MobileAccordion.tsx
 * [Readme] --------------------------------------------------------------------------------------
 *
 * 데스크탑용 아코디언 컴포넌트
 *
 * -----------------------------------------------------------------------------------------------
 */

import { UpArrowIcon } from 'common-modules/general/assets/Styles/Mobile/icon';
import { ResponseFAQList } from 'common-modules/general/API/support/types';
import { APIClientBaseURL } from 'common-modules/general/Config/constants';
import React from 'react';
import styled from 'styled-components';
import InnerHTML from 'dangerously-set-html-content';

const AccordionContainer = styled.div`
  border-bottom: 1px solid #ccc;
  position: relative;
  width: 100%;
`;
const AccordionHeader = styled.div<{ open: boolean }>`
  padding: 21px 47px;
  background-color: #fff;
  position: relative;
  cursor: pointer;
  box-sizing: border-box;
  ${UpArrowIcon} {
    display: inline-block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: ${props => (props.open ? 'rotate(-180deg) translateY(50%)' : 'rotate(0) translateY(-50%)')};
  }
`;
const AccordionContent = styled.div<{ open: boolean }>`
  display: block;
  word-break: keep-all;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #f7f7f7;
  position: relative;
  padding: ${props => (props.open ? '1.25rem 2.25rem 0.75rem 3rem' : '0 2.25rem 0 3rem')};
  max-height: ${props => (props.open ? '2000px' : '0')};
  transition: 0.3s;
`;

const Icon1 = styled.div`
  color: #ff671d;
  display: inline-block;
  box-sizing: border-box;
  vertical-align: middle;
  cursor: pointer;
  font-family: 'SDGothicNeobTTF-dMd';
  font-size: 18px;
  position: absolute;
  top: 50%;
  left: 21px;
  margin-top: -12px;
`;
const Icon2 = styled.div`
  display: inline-block;
  box-sizing: border-box;
  vertical-align: middle;
  cursor: pointer;
  font-family: 'SDGothicNeobTTF-dMd';
  font-size: 1.125rem;
  position: absolute;
  top: 1.25rem;
  left: 1.3125rem;
  color: #999;
`;
const Type = styled.div`
  font-size: 0.8125rem;
  margin-bottom: 0.5rem;
  text-align: left;
  color: #999;
  width: 100%;
  display: block;
`;
const Question = styled.div`
  width: 100%;
  font-size: 15px;
  text-align: left;
  line-height: 1.4;
  font-family: 'SDGothicNeobTTF-dMd';
  vertical-align: middle;
  color: #333;
  box-sizing: border-box;
  word-break: keep-all;
  word-wrap: break-word;
`;
const Content = styled.div`
  width: 100%;
  font-size: 0.8125rem;
  line-height: 1.5;

  img {
    max-width: 100%;
    height: auto;
  }
`;
const FileDownLine = styled.a`
  margin-top: 1.25rem;
  display: block;
`;

interface Props {
  faq: ResponseFAQList;
  active: boolean;

  setActiveNumber(no: string): void;
}
const Accordion: React.FC<Props> = ({ faq, active, setActiveNumber = () => {} }) => {
  return (
    <AccordionContainer>
      <AccordionHeader onClick={() => setActiveNumber(active ? '' : faq.noSral)} open={active}>
        <Icon1>Q</Icon1>

        {/* <Type>{faq.faqType}</Type> */}
        <Question>{faq.faqTitle}</Question>

        <UpArrowIcon />
      </AccordionHeader>
      <AccordionContent open={active}>
        <Icon2>A</Icon2>
        <Content>
          <InnerHTML html={faq.faqDesc} />

          {faq.fullPath && (
            <FileDownLine target="_blank" href={`${APIClientBaseURL.file}${faq.fullPath}`} download>
              다운로드
            </FileDownLine>
          )}
        </Content>
      </AccordionContent>
    </AccordionContainer>
  );
};

export default Accordion;
